import React, { forwardRef } from "react";
import { string, element, arrayOf, oneOfType } from "prop-types";
import { twMerge } from "tailwind-merge";

const ContentWrapper = forwardRef((props, ref) => {
  const { className, children, dataId } = props;
  return (
    <div
      className={twMerge(
        "flex justify-center w-full bg-primaryLight text-black px-0 md:px-8",
        className
      )}
      data-id={dataId ?? ""}
      ref={ref}
    >
      <div className="flex justify-center items-center w-full max-w-pageContent">
        {children}
      </div>
    </div>
  );
});

ContentWrapper.displayName = "ContentWrapper";

ContentWrapper.propTypes = {
  className: string,
  dataId: string,
  children: oneOfType([arrayOf(element), element]),
};

export default ContentWrapper;
